import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { useResponsive } from '@sg/garnish';

import {
  AccountScreenBorderedSection,
  AccountScreenSection,
  AccountScreenSectionTitle,
} from '../../../Account';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardAccountSectionContainer = (props: Props) => {
  const { children, dataSet } = props;

  const { formatMessage } = useIntl();
  const { match } = useResponsive();

  const accountScreenSectionStyles = match([
    styles.sectionContainerXS,
    undefined,
  ]);

  return (
    <View {...(dataSet ? { dataSet } : {})}>
      <AccountScreenSectionTitle
        title={formatMessage(messages.accountGiftCardsTitle)}
      />
      <AccountScreenSection style={accountScreenSectionStyles}>
        <AccountScreenBorderedSection>{children}</AccountScreenBorderedSection>
      </AccountScreenSection>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountGiftCardsTitle: {
    defaultMessage: 'Gift card',
    description: 'Account | Gift Cards | Title',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  sectionContainerXS: {
    flexGrow: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Pick<ViewProps, 'children'> & { dataSet?: Record<string, string> };
